module.exports = __webpack_public_path__ + "img/directvgo.b65dee5d.svg";